import type {TSelectItem} from "@chayka/ui";

export type UserType =
  | "Музыкальная группа"
  | "Преподаватель по вокалу"
  | "Преподаватель по гитаре"
  | "Преподаватель по ударным"
  | "Индивидуальный барабанщик"
  | "Индивидуальный вокалист"
  | "Музыкальная школа"
  | "Сотрудник студии Чайка"
  | "Звукорежиссёр"
  | "Саксофонист";

export const USER_TYPE_ITEMS: Array<TSelectItem<UserType>> = [
  {label: "Музыкальная группа", value: "Музыкальная группа"},
  {label: "Преподаватель по вокалу", value: "Преподаватель по вокалу"},
  {label: "Преподаватель по гитаре", value: "Преподаватель по гитаре"},
  {label: "Преподаватель по ударным", value: "Преподаватель по ударным"},
  {label: "Индивидуальный барабанщик", value: "Индивидуальный барабанщик"},
  {label: "Индивидуальный вокалист", value: "Индивидуальный вокалист"},
  {label: "Музыкальная школа", value: "Музыкальная школа"},
  {label: "Сотрудник студии Чайка", value: "Сотрудник студии Чайка"},
  {label: "Звукорежиссёр", value: "Звукорежиссёр"},
  {label: "Саксофонист", value: "Саксофонист"},
];
